import React from 'react';
import { MinusCircle, X } from 'lucide-react';
import Logo from '../Logo';

interface ChatHeaderProps {
  onMinimize: () => void;
  onClose: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onMinimize, onClose }) => {
  return (
    <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between bg-blue-600 dark:bg-blue-700 rounded-t-xl">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-white dark:bg-gray-200 rounded-full flex items-center justify-center">
          <Logo className="w-7 h-7 text-gray-900 dark:text-gray-800" />
        </div>
        <div>
          <h3 className="text-white font-semibold">Shopiweb</h3>
          <p className="text-blue-100 text-sm">Assistant Premium</p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={onMinimize}
          className="p-1 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-full transition-colors"
        >
          <MinusCircle className="w-5 h-5 text-white" />
        </button>
        <button
          onClick={onClose}
          className="p-1 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-full transition-colors"
        >
          <X className="w-5 h-5 text-white" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;